import amex from './amex.svg'
import elo from './elo.svg'
import hipercard from './hipercard.svg'
import mastercard from './mastercard.svg'
import visa from './visa.svg'

export default {
  amex,
  elo,
  hipercard,
  mastercard,
  visa
}
